<erbfactors-loading-screen></erbfactors-loading-screen>
<section
  class="route-wrapper"
  [@routeAnimations]="prepareRoute(outlet)"
  fxFlex="grow"
>
  <router-outlet #outlet="outlet"></router-outlet>
</section>
<erbfactors-cookies-alert></erbfactors-cookies-alert>